export interface Faq {
  question: string
  answer: string
}

/**
 * Questions are phrased the way a buyer actually asks them, and every answer
 * leads with the answer in its first clause. This is what an answer engine
 * quotes, so an answer that begins with context rather than a conclusion is
 * wasted.
 */
export const GENERAL_FAQS: Faq[] = [
  {
    question: 'What does Cavalla Solution do?',
    answer:
      'Cavalla Solution is a consulting firm in market intelligence, data led growth and augmented intelligence. We work through three advisory lines, Cavalla Intelligence for market evidence, Cavalla Growth for demand, and Cavalla AI for governed adoption, and one platform for government, Cavalla Gov. We serve organisations across Africa and globally.',
  },
  {
    question: 'What is augmented intelligence, and how is it different from artificial intelligence?',
    answer:
      'Augmented intelligence uses machines to widen what a person can consider, and leaves the decision with that person. Artificial intelligence, used on its own, aims to make the decision. Our method has four steps: we capture the evidence, apply machine analysis alongside human judgement, enable your team to run it, and leave each decision with a named owner.',
  },
  {
    question: 'Which sectors does Cavalla Solution work in?',
    answer:
      'We work across ten priority sectors: NGOs, government, banking, health, agriculture, small and medium enterprises, education, energy, logistics and telecoms. Most of our work is in Africa, for organisations that also answer to international funders and boards.',
  },
  {
    question: 'How much does an engagement cost?',
    answer:
      'We do not publish fees. Scope, timing and fees are set out in a written proposal after a discovery call, because the same named engagement can differ several fold in scope between two organisations. A discovery call lasts thirty minutes and costs nothing.',
  },
  {
    question: 'How do we start working with Cavalla Solution?',
    answer:
      'Start with a thirty minute discovery call, or take our free AI readiness assessment first if artificial intelligence is the question. The assessment scores you out of one hundred across data, skills, use cases, governance and budget, and returns three recommended next steps.',
  },
  {
    question: 'Where is our data held?',
    answer:
      'Personal data is held in the European Union. Client deliverables are held in private object storage and reached only through short lived signed links after an access check, and every download is logged.',
  },
]

export const GOV_FAQS: Faq[] = [
  {
    question: 'What is Cavalla Gov?',
    answer:
      'Cavalla Gov is a platform that gives a ministry of finance one live picture of how the national development plan is being delivered, and where development partner funding lands against it. It has three modules: Delivery Tracker, Development Finance Intelligence and AI Reporting.',
  },
  {
    question: 'How is Cavalla Gov different from the three advisory lines?',
    answer:
      'Cavalla Gov is a platform rather than an advisory engagement. It draws on all three lines, taking indicator baselines from Cavalla Intelligence, development finance mapping from Cavalla Growth, and its drafting and early warning layer from Cavalla AI, but a government licenses it as a working system rather than as a piece of advice.',
  },
  {
    question: 'Does Cavalla Gov let AI make decisions about citizens or programmes?',
    answer:
      'No. Where the platform uses AI it drafts and it flags, and nothing more. Every AI drafted output is labelled as AI generated and is reviewed and approved by a named official before it leaves the platform, and no automated decision is taken about an individual citizen.',
  },
  {
    question: 'Who owns the data in Cavalla Gov?',
    answer:
      'The government does. Data stays under the government’s control, in a region the country accepts, and a full export is available at any time.',
  },
  {
    question: 'How does a government start with Cavalla Gov?',
    answer:
      'We start with one ministry and a small set of agencies, so the first quarterly reporting cycle is completed rather than designed. This is usually financed as development partner technical assistance rather than a direct purchase, then scaled across agencies and, over time, across countries.',
  },
  {
    question: 'Does Cavalla Gov require new systems or a new reporting framework?',
    answer:
      'No. Agencies report against the plan’s own pillars, programmes and indicators, through a simple form or a bulk upload, and the platform is built to work on a mid range phone on a slow connection because that is how most agency officers will reach it.',
  },
]
